import cookie from 'js-cookie'

// KEY 值定义 ******************************************************
const TOKEN = 'TOKEN' // 访问令牌
const USERINFO = 'USERINFO' // 用户信息
const USERALIYUN = 'USERALIYUN' // 用户阿里云信息
const SYSTEMINFO = 'SYSTEMINFO' // 系统信息
/**
 * 获取TOKEN 设置TOKEN 移除TOKEN
 */
export function getToken() {
  return cookie.get(TOKEN)
}
export function setToken(tokenVal) {
  return cookie.set(TOKEN, tokenVal)
}
export function removeToken() {
  return cookie.remove(TOKEN)
}

/**
 * 用户信息
 */
export function getUSERINFO() {
  return cookie.get(USERINFO)
}
export function setUSERINFO(USERNAMEVal) {
  return cookie.set(USERINFO, USERNAMEVal)
}
export function removeUSERINFO() {
  return cookie.remove(USERINFO)
}

/**
 * 系统信息
 */
export function getSYSTEMINFO() {
  return cookie.get(SYSTEMINFO)
}
export function setSYSTEMINFO(USERNAMEVal) {
  return cookie.set(SYSTEMINFO, USERNAMEVal)
}
export function removeSYSTEMINFO() {
  return cookie.remove(SYSTEMINFO)
}

/**
 * 用户阿里云信息
 */
export function getUserAliyun() {
  return cookie.get(USERALIYUN)
}
export function setUserAliyun(USERNAMEVal) {
  return cookie.set(USERALIYUN, USERNAMEVal)
}
export function removeUserAliyun() {
  return cookie.remove(USERALIYUN)
}
